import * as types from '../../mutation_types';
import { https , httpsFile } from './http.js';

const state = {
    storage_location:'',
    search:'',
    page:1,
    currentpage:5,
    loading:false,
    datefrom:'',
    dateto:'',
    time:'',
    doctype:'',
    transaction:'',
    data:{}
};
const getters = {
    storage_location :state => state.storage_location,
    search           :state => state.search,
    page             :state => state.page,
    currentpage      :state => state.currentpage,
    loading          :state => state.loading,
    datefrom         :state => state.datefrom,
    dateto           :state => state.dateto,
    time             :state => state.time,
    doctype          :state => state.doctype,
    transaction      :state => state.transaction,
    data             :state => state.data,
};
const actions = {
    async fetchData( { commit } ) {
        commit( types.MH_LOADING , true );
        https( ).get( `material-history/${ state.search }?page=${ state.page }&currentpage=${ state.currentpage }&storage_location=${ state.storage_location }&datefrom=${ state.datefrom }&dateto=${ state.dateto }&time=${ state.time }&doctype=${ state.doctype }&transaction=${ state.transaction }` )
                .then( async( response )=> {
                    commit( types.MATERIAL_HISTORIES , response.data );
                } )
                .catch( error=>{
                    console.log(error);
                } )
        commit( types.MH_LOADING , false );
    }
};
const mutations = {
    [ types.MH_SEARCH ]( state , data ){
        state.search = data;
    },
    [ types.MH_PAGE ]( state , data ){
        state.page = data;
    },
    [ types.MH_CURRENTPAGE ]( state , data ){
        state.currentpage = data;
    },
    [ types.MH_LOADING ]( state , data ){
        state.loading = data;
    },
    [ types.MH_STORLOC ]( state , data ){
        state.storage_location = data;
    },
    [ types.MH_DATEFROM ]( state , data ){
        state.datefrom = data;
    },
    [ types.MH_DATETO ]( state , data ){
        state.dateto = data;
    },
    [ types.MH_TIME ]( state , data ){
        state.time = data;
    },
    [ types.MH_DOCTYPE ]( state , data ){
        state.doctype = data;
    },
    [ types.MH_TRANSACTION ]( state , data ){
        state.transaction = data;
    },
    [ types.MATERIAL_HISTORIES ]( state , data ){
        $.each( data.data , ( key , value )=> {
            if( state.storage_location == value.issuing_LGORT ){
                value.doctype = `Stock Transfer (OUT) - ${ value.sth_receiving_plant }`;
            } else if( state.storage_location == value.receiving_LGORT ){
                value.doctype = `Stock Transfer (IN) - ${ value.sth_issuing_plant }`;
            }else{
                if( value.rph_status == '2' ){
                    value.doctype = 'Goods Receipt';
                } else if( value.rph_status == '3' ){
                    value.doctype = 'Goods Receipt Reversal';
                }
            }
        } )
        state.data = data;
    },
};

export {
    state,getters,actions,mutations
}